#import "../fragments/landing-page-full-fragment.graphql"

mutation TogglePageStatus($input: SupportPageStatusToggleInput!) {
    togglePageStatus(input: $input) {
        page {
            ...LandingPageFullFragment
        }
    }
}
